import { createAction, props } from '@ngrx/store';
import { IOrderChannel, Setting } from 'src/app/shared/interfaces/setting.interface';

export const retrieveSetting = createAction('[Setting Data] Retrieve Setting', props<{ payload: Setting }>());
export const updateSetting = createAction('[Setting Data] Update Setting', props<{ payload: Setting }>());
export const clearSetting = createAction('[Setting Data] Clear Setting');

export const updateTheme = createAction('[Setting Data] Update Theme', props<{ theme: string }>());

export const updateCountry = createAction('[Setting Data] Update Country', props<{ country_id: string, country_name: string }>());
export const updateChain = createAction('[Setting Data] Update Chain', props<{ chain_id: string, chain_name: string}>());
export const updateRestaurant = createAction('[Setting Data] Update Restaurant', props<{ restaurant_id: string, restaurant_name: string}>());
export const updateChainTimeZone = createAction('[Setting Data] Update Time Zone', props<{ time_zone: string}>());
export const updateDomainURL = createAction('[Setting Data] Update Domain URL', props<{ domain_url: string}>());
export const updateOrganizationName = createAction('[Setting Data] Update Organization Name', props<{ organization_name: string}>());

export const updateOrderChannels = createAction('[Setting Data] Update Order Channels', props<{ order_channels: IOrderChannel[]}>());

export const updateDisableType = createAction('[Setting Data] Update Disable Type', props<{ disable_model_name: string }>());
